function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "#FFAF20",
  strokeWidth: 0.7,
  d: "M32.376 2.042H6.53c-2.461 0-4.488 1.96-4.488 4.341v12.952c0 2.38 2.027 4.34 4.488 4.34h25.918c2.462 0 4.489-1.96 4.489-4.34V6.383c-.073-2.38-2.027-4.34-4.561-4.34z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFAF20",
  fillRule: "nonzero",
  d: "M2.188 6.73h34.624L37 6.56V5.9l-.188-.169H2.188L2 5.901v.66zM2.188 10.96h34.624l.188-.168v-.66l-.188-.17H2.188l-.188.17v.66zM21.371 16.955v-.17H18.91c-.314 0-.537.216-.537.52 0 .303.223.519.537.519h2.461c.314 0 .537-.216.537-.52 0-.303-.223-.519-.537-.519v.17zM24.919 16.955v-.17h-2.462c-.313 0-.537.216-.537.52 0 .303.224.519.537.519h2.462c.314 0 .537-.216.537-.52 0-.303-.223-.519-.537-.519v.17zM28.466 16.955v-.17h-2.461c-.314 0-.537.216-.537.52 0 .303.223.519.537.519h2.461c.314 0 .537-.216.537-.52 0-.303-.223-.519-.537-.519v.17zM32.014 16.955v-.17h-2.462c-.314 0-.537.216-.537.52 0 .303.223.519.537.519h2.462c.314 0 .537-.216.537-.52 0-.303-.223-.519-.537-.519v.17z"
}));

var SvgRequestCardMenuIcon = function SvgRequestCardMenuIcon(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 26,
    style: {
      background: "#fff"
    },
    viewBox: "0 0 39 26",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRequestCardMenuIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/request_card_menu_icon.de5c6c82.svg";
export { ForwardRef as ReactComponent };